import React from "react";
// Stripe imports - commented out
// import { loadStripe } from "@stripe/stripe-js";
// import {
//   EmbeddedCheckoutProvider,
//   EmbeddedCheckout,
// } from "@stripe/react-stripe-js";
// import useStripePayment from "../hooks/useStripePayment";

import SquarePayment from "./SquarePayment";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

// const stripe_public_key = process.env.REACT_APP_PUBLIC_STRIPE_KEY;
// const stripePromise = loadStripe(stripe_public_key!);

// Base interface for common properties
interface BasePaymentProps {
  pricing: number | null;
  handleOrder: (paymentMethod: string, transactionId?: string) => void;
  isOpen: boolean;
  onClose: () => void;
  productDescription: string;
  phone: string;
}

export default function PaymentPage(props: BasePaymentProps) {
  const { pricing, handleOrder, isOpen, onClose } = props;

  // Stripe implementation - commented out
  // const [clientSecret, setClientSecret] = useState<string | null>(null);
  // const [sessionId, setSessionId] = useState<string | null>(null);
  // const [isPaymentDone, setPaymentDone] = useState(false);
  // const [paymentSession, setPaymentSession] = useState<any>(null);
  // const { getCheckoutSession, saveStripeTransactions, getPaymentSession } = useStripePayment();

  // useEffect(() => {
  //   console.log("pricing", pricing);
  //   if (isOpen && pricing) {
  //     const fetchSecret = async () => {
  //       try {
  //         console.log("payment2", sessionId);
  //         const secret = await getCheckoutSession(pricing, productDescription);
  //         const parsedSecret = typeof secret === "string" ? JSON.parse(secret) : secret;
  //         if (!parsedSecret.clientSecret || !parsedSecret.sessionId) {
  //           throw new Error("Invalid secret format");
  //         }
  //         setClientSecret(parsedSecret.clientSecret);
  //         setSessionId(parsedSecret.sessionId);
  //       } catch (error) {
  //         console.error("Error fetching checkout session:", error);
  //         onClose();
  //       }
  //     };
  //     fetchSecret();
  //   }
  // }, [isOpen, pricing, onClose]);

  // useEffect(() => {
  //   if (!isOpen) {
  //     setClientSecret(null);
  //   }
  // }, [isOpen]);

  // useEffect(() => {
  //   console.log("payment", sessionId);
  //   if (!isPaymentDone || !sessionId) return;
  //   const handlePaymentComplete = async () => {
  //     console.log("payment1", sessionId);
  //     const data = await getPaymentSession(sessionId);
  //     setPaymentSession(data);
  //   };
  //   handlePaymentComplete();
  // }, [isPaymentDone, sessionId]);

  // useEffect(() => {
  //   const handleSuccessfulPayment = async () => {
  //     console.log("payment3", paymentSession);
  //     if (!paymentSession || paymentSession.session.payment_status !== "paid") {
  //       return;
  //     }
  //     try {
  //       setPaymentDone(true);
  //       await saveStripeTransactions(
  //         props.phone,
  //         (paymentSession.session.amount_total / 100).toFixed(2),
  //         paymentSession.session.currency,
  //         paymentSession.session.payment_intent
  //       );
  //       handleOrder("stripe");
  //       onClose();
  //       console.log("payment4", paymentSession);
  //     } catch (error) {
  //       console.error("Error processing successful payment:", error);
  //     }
  //   };
  //   handleSuccessfulPayment();
  // }, [paymentSession]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-h-[80vh] overflow-y-auto sm:max-w-[600px] bg-white z-[99999]">
        <DialogHeader>
          <DialogTitle>{"Purchase Content"}</DialogTitle>
        </DialogHeader>

        {/* Square Payment Implementation */}
        {pricing && pricing > 0 ? (
          <SquarePayment
            pricing={pricing}
            handleOrder={(paymentMethod: string, transactionId?: string) => {
              handleOrder(paymentMethod, transactionId);
              onClose();
            }}
          />
        ) : (
          <p className="text-center text-gray-500">Invalid payment amount</p>
        )}

        {/* Stripe Implementation - commented out */}
        {/* {!clientSecret ? (
          <div className="space-y-4">
            <Skeleton className="h-[50px] w-full" />
            <Skeleton className="h-[50px] w-full" />
            <Skeleton className="h-[50px] w-full" />
          </div>
        ) : (
          <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{
              fetchClientSecret: () => Promise.resolve(clientSecret),
              onComplete: () => {
                setPaymentDone(true);
              },
            }}
          >
            <EmbeddedCheckout className="w-full" />
          </EmbeddedCheckoutProvider>
        )} */}
      </DialogContent>
    </Dialog>
  );
}
